import { useEffect, useRef } from 'react';

/** A nyitott saját (nem Headless UI) ablakok sorrendje: Esc csak a legfelsőt zárja. */
const stack: number[] = [];
let nextId = 1;

/**
 * Esc-re bezárja a saját készítésű ablakot. Egymásba nyitott ablakoknál csak a
 * legfelsőt, és akkor sem, ha fölötte egy Headless UI dialógus van nyitva (az
 * maga kezeli az Esc-et) - így egy Esc nem zár be egyszerre több szintet.
 */
export const useEscapeToClose = (active: boolean, onClose: () => void) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!active) return undefined;

    const id = nextId++;
    stack.push(id);

    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || stack[stack.length - 1] !== id) return;
      if (document.querySelector('[id^="headlessui-dialog"][data-open]')) return;
      e.stopPropagation();
      onCloseRef.current();
    };

    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('keydown', handler);
      const index = stack.indexOf(id);
      if (index >= 0) stack.splice(index, 1);
    };
  }, [active]);
};
